import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { CompanyService } from "../../../_services/company.service";

@Component({
  selector: "app-edit-company",
  templateUrl: "./edit-company.component.html",
  styleUrls: ["./edit-company.component.css"],
})
export class EditCompanyComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_company = false;
  private company_id: number;

  constructor(private service: CompanyService) {}

  edit_company = new FormGroup({
    email: new FormControl(""),
    name: new FormControl("", [Validators.required]),
    phone: new FormControl(""),
    is_client: new FormControl(),
    is_seller: new FormControl(),
    speaks_french: new FormControl(),
  });

  ngOnInit() {}

  openModal(company) {
    this.company_id = company.id; // Set the Contact_id needed in the Update Contact URL
    this.edit_company.patchValue({
      // Fill the FormGroup
      email: company.email,
      name: company.name,
      phone: company.phone,
      is_client: company.is_client,
      is_seller: company.is_seller,
      speaks_french: company.speaks_french,
    });

    jQuery("#edit-company-modal").modal({ inverted: true }).modal("show"); // Show the Modal
  }

  // Update Company
  submitCompanyForm() {
    this.edit_company.disable(); // Disable the form to avoid changes during the Updating process
    this.updating_company = true; // Trigger the Loading button apparition
    jQuery("#edit-company-modal").modal({ closable: false }); // Set the modal unclosable during the Updating process
    this.service
      .updateCompany(this.company_id, this.edit_company.value) // Create the Contact
      .subscribe((response) => {
        jQuery("#edit-company-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.updating_company = false; // Disable the loading button apparition
        this.edit_company.enable(); // Re Enable the Form
        this.edit_company.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company/edit-company/edit-company.component.ts